import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getFooterDrilldownData: { [key in ModuleConfig]: ModuleFields[] } = {
  socialMediaIcons: [
    {
      fieldName: "Name",
      fieldValue: "field_social_media_name",
      className: "col-span-6",
      type: "text",
      name: "field_social_media_name",
      formType: "input",
      label: "Name",
      placeholder: "Enter Name",
      validation: { required: "Name is required" },
      imageDimension: {
        width: 30,
        height: 30
      }
    },
    // {
    //   fieldName: "Name (MS)",
    //   fieldValue: "field_social_media_name_ms",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_social_media_name_ms",
    //   formType: "input",
    //   label: "Name (MS)",
    //   placeholder: "Enter Name (MS)",
    //   // validation: { required: "Name (MS) is required" },
    // },
    // {
    //   fieldName: "Name (ZH)",
    //   fieldValue: "field_social_media_name_zh",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_social_media_name_zh",
    //   formType: "input",
    //   label: "Name (ZH)",
    //   placeholder: "Enter Name (ZH)",
    //   // validation: { required: "Name (ZH) is required" },
    // },
    {
      fieldName: "Link",
      fieldValue: "field_social_media_link",
      className: "col-span-6",
      type: "text",
      name: "field_social_media_link",
      formType: "input",
      label: "Link",
      placeholder: "Enter Link",
      validation: { required: "Link is required" }
    },

    {
      "fieldName": "Icon",
      "fieldValue": "field_social_media_icon",
      "className": "col-span-6",
      usedFileType: 'image/*',
      "type": "image",
      "name": "field_social_media_icon",
      "formType": "file",
      "label": "Icon",
      "placeholder": "Enter Icon",
      validation: { required: 'Icon is Required' },
      imageDimension: {
        width: 30,
        height: 30
      }
    },

    {
      fieldName: "Published",
      fieldValue: "publish",
      className: "col-span-12",
      type: "checkbox",
      name: "publish",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
  contactCentre: [
    {
      "fieldName": "Name",
      "fieldValue": "name",
      "className": "col-span-6",
      "type": "text",
      "name": "name",
      "formType": "input",
      "label": "Name",
      "placeholder": "Enter Name",
      validation: { required: 'Name is Required' }
    },
    {
      "fieldName": "Address Email",
      "fieldValue": "field_address_email",
      "className": "col-span-6",
      "type": "text",
      "name": "field_address_email",
      "formType": "multiInput",
      note: "Type and press Enter to add more values",
      "label": "Address Email",
      "placeholder": "Enter Address Email",
      "validation": {
        "required": "Address Email is required",
        "validate": (value: string[]) => {
          if (!value || value.length === 0) {
            return "Address Email is required";
          }
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          const invalid = value.find((v) => !emailRegex.test(v));
          return invalid ? `"${invalid}" is not a valid email address` : true;
        }
      }
    },
    {
      "fieldName": "Address Heading (EN)",
      "fieldValue": "field_address_heading_en",
      "className": "col-span-6",
      "type": "text",
      "name": "field_address_heading_en",
      "formType": "textarea",
      "label": "Address Heading (EN)",
      "placeholder": "Enter Address Heading (EN)",
      validation: { required: 'Address Heading (EN) is Required' }
    },
    {
      "fieldName": "Address Heading (MS)",
      "fieldValue": "field_address_heading_ms",
      "className": "col-span-6",
      "type": "text",
      "name": "field_address_heading_ms",
      "formType": "textarea",
      "label": "Address Heading (MS)",
      "placeholder": "Enter Address Heading (MS)",
      // validation:{required:'Address Heading (MS) is Required'}
    },
    {
      "fieldName": "Address Heading (ZH)",
      "fieldValue": "field_address_heading_zh",
      "className": "col-span-6",
      "type": "text",
      "name": "field_address_heading_zh",
      "formType": "textarea",
      "label": "Address Heading (ZH)",
      "placeholder": "Enter Address Heading (ZH)",
      // validation:{required:'Address Heading (ZH) is Required'}
    },
    {
      "fieldName": "Address (EN)",
      "fieldValue": "field_address_en",
      "className": "col-span-6",
      "type": "text",
      "name": "field_address_en",
      "formType": "textarea",
      "label": "Address (EN)",
      "placeholder": "Enter Address (EN)",
      validation: { required: 'Address (EN) is Required' }
    },
    {
      "fieldName": "Address (MS)",
      "fieldValue": "field_address_ms",
      "className": "col-span-6",
      "type": "text",
      "name": "field_address_ms",
      "formType": "textarea",
      "label": "Address (MS)",
      "placeholder": "Enter Address (MS)",
      // validation:{required:'Address (MS) is Required'}
    },
    {
      "fieldName": "Address (ZH)",
      "fieldValue": "field_address_zh",
      "className": "col-span-6",
      "type": "text",
      "name": "field_address_zh",
      "formType": "textarea",
      "label": "Address (ZH)",
      "placeholder": "Enter Address (ZH)",
      // validation:{required:'Address (ZH) is Required'}
    },
    {
      "fieldName": "Mobile Number",
      "fieldValue": "field_mobile_number",
      "className": "col-span-6",
      "type": "text",
      "name": "field_mobile_number",
      "formType": "multiInput",
      "label": "Mobile Number",
      "placeholder": "Enter Mobile Number",
      "validation": {
        "required": "Mobile Number is required",
        "validate": (value: string[]) => {
          if (!value || value.length === 0) {
            return "Mobile Number is required";
          }
          // Regex: allows only digits, length 8–15
          const mobileRegex = /^[+()0-9\s-]{6,20}$/;
          const invalid = value.find((v) => !mobileRegex.test(v));
          return invalid ? `"${invalid}" is not a valid mobile number` : true;
        }
      }
    },
    {
      "fieldName": "Email Icon",
      "fieldValue": "email_icon_image",
      "className": "col-span-6",
      usedFileType: 'image/*',
      "type": "image",
      "name": "email_icon_image",
      "formType": "file",
      "label": "Email Icon",
      "placeholder": "Enter Email Icon",
      validation: { required: 'Email Icon is Required' },
      imageDimension: {
        width: 20,
        height: 20
      }
    },
    {
      "fieldName": "Mobile Icon",
      "fieldValue": "mobile_icon_image",
      "className": "col-span-6",
      usedFileType: 'image/*',
      "type": "image",
      "name": "mobile_icon_image",
      "formType": "file",
      "label": "Mobile Icon",
      "placeholder": "Enter Mobile Icon",
      validation: { required: 'Mobile Icon is Required' },
      imageDimension: {
        width: 20,
        height: 20
      }
    },
  ],
  copyrights: [
    {
      "fieldName": "Copyrights (EN)",
      "fieldValue": "field_copyrights_en",
      "className": "col-span-6",
      "type": "text",
      "name": "field_copyrights_en",
      "formType": "richText",
      "label": "Copyrights (EN)",
      "placeholder": "Enter Copyrights (EN)",
      "validation": { "required": "Copyrights (EN) is required" }
    },
    {
      "fieldName": "Copyrights (MS)",
      "fieldValue": "field_copyrights_ms",
      "className": "col-span-6",
      "type": "text",
      "name": "field_copyrights_ms",
      "formType": "richText",
      "label": "Copyrights (MS)",
      "placeholder": "Enter Copyrights (MS)",
      // "validation": { "required": "Copyrights (MS) is required" }
    },
    {
      "fieldName": "Copyrights (ZH)",
      "fieldValue": "field_copyrights_zh",
      "className": "col-span-6",
      "type": "text",
      "name": "field_copyrights_zh",
      "formType": "richText",
      "label": "Copyrights (ZH)",
      "placeholder": "Enter Copyrights (ZH)",
      // "validation": { "required": "Copyrights (ZH) is required" }
    },
    {
      fieldName: "Privacy Policy Text (EN)",
      fieldValue: "field_privacy_policy_text_en",
      className: "col-span-6",
      type: "text",
      name: "field_privacy_policy_text_en",
      formType: "input",
      label: "Privacy Policy Text (EN)",
      placeholder: "Enter Privacy Policy Text (EN)",
      validation: { required: "Privacy Policy Text (EN) is required" },
    },
    {
      fieldName: "Privacy Policy Text (MS)",
      fieldValue: "field_privacy_policy_text_ms",
      className: "col-span-6",
      type: "text",
      name: "field_privacy_policy_text_ms",
      formType: "input",
      label: "Privacy Policy Text (MS)",
      placeholder: "Enter Privacy Policy Text (MS)",
      // validation: { required: "Privacy Policy Text (MS) is required" },
    },
    {
      fieldName: "Privacy Policy Text (ZH)",
      fieldValue: "field_privacy_policy_text_zh",
      className: "col-span-6",
      type: "text",
      name: "field_privacy_policy_text_zh",
      formType: "input",
      label: "Privacy Policy Text (ZH)",
      placeholder: "Enter Privacy Policy Text (ZH)",
      // validation: { required: "Privacy Policy Text (ZH) is required" },
    },
    {
      "fieldName": "Copyrigths PDF (EN)",
      "fieldValue": "field_copyrights_pdf_en",
      "className": "col-span-6",
      usedFileType: ".pdf",
      "type": "pdf",
      "name": "field_copyrights_pdf_en",
      "formType": "file",
      "label": "Copyrigths PDF (EN)",
      "placeholder": "Enter Copyrigths PDF (EN)",
      validation: { required: 'Copyrigths PDF (EN) is Required' }
    },
    {
      "fieldName": "Copyrigths PDF (MS)",
      "fieldValue": "field_copyrights_pdf_ms",
      "className": "col-span-6",
      usedFileType: ".pdf",
      "type": "pdf",
      "name": "field_copyrights_pdf_ms",
      "formType": "file",
      "label": "Copyrigths PDF (MS)",
      "placeholder": "Enter Copyrigths PDF (MS)",
      // validation:{required:'Copyrigths PDF (MS) is Required'}
    },
    {
      "fieldName": "Copyrigths PDF (ZH)",
      "fieldValue": "field_copyrights_pdf_zh",
      "className": "col-span-6",
      "type": "pdf",
      usedFileType: ".pdf",
      "name": "field_copyrights_pdf_zh",
      "formType": "file",
      "label": "Copyrigths PDF (ZH)",
      "placeholder": "Enter Copyrigths PDF (ZH)",
      // validation:{required:'Copyrigths PDF (ZH) is Required'}
    },
  ],
  contents: [
    {
      "fieldName": "Title (EN)",
      "fieldValue": "content_title_en",
      "className": "col-span-6",
      "type": "text",
      "name": "content_title_en",
      "formType": "input",
      "label": "Title (EN)",
      "placeholder": "Enter Title (EN)",
      validation: { required: 'Title (EN) is Required' }
    },
    {
      "fieldName": "Title (MS)",
      "fieldValue": "content_title_ms",
      "className": "col-span-6",
      "type": "text",
      "name": "content_title_ms",
      "formType": "input",
      "label": "Title (MS)",
      "placeholder": "Enter Title (MS)",
      // validation:{required:'Title (MS) is Required'}
    },
    {
      "fieldName": "Title (ZH)",
      "fieldValue": "content_title_zh",
      "className": "col-span-6",
      "type": "text",
      "name": "content_title_zh",
      "formType": "input",
      "label": "Title (ZH)",
      "placeholder": "Enter Title (ZH)",
      // validation:{required:'Title (ZH) is Required'}
    },
    // {
    //   "fieldName": "Content Text (EN)",
    //   "fieldValue": "content_text_en",
    //   "className": "col-span-6",
    //   "type": "text",
    //   "name": "content_text_en",
    //   "formType": "multiInput",
    //   note: "Type and press Enter to add more values",
    //   "label": "Content Text (EN)",
    //   "placeholder": "Enter Content Text (EN)",
    //   "validation": { "required": "Content Text (EN) is required" }
    // },
    // {
    //   "fieldName": "Content Text (MS)",
    //   "fieldValue": "content_text_ms",
    //   "className": "col-span-6",
    //   "type": "text",
    //   "name": "content_text_ms",
    //   "formType": "multiInput",
    //   note: "Type and press Enter to add more values",
    //   "label": "Content Text (MS)",
    //   "placeholder": "Enter Content Text (MS)",
    //   // "validation": { "required": "Content Text (MS) is required" }
    // },
    // {
    //   "fieldName": "Content Text (ZH)",
    //   "fieldValue": "content_text_zh",
    //   "className": "col-span-6",
    //   "type": "text",
    //   "name": "content_text_zh",
    //   "formType": "multiInput",
    //   note: "Type and press Enter to add more values",
    //   "label": "Content Text (ZH)",
    //   "placeholder": "Enter Content Text (ZH)",
    //   // "validation": { "required": "Content Text (ZH) is required" }
    // },
    // {
    //   "fieldName": "Content URL",
    //   "fieldValue": "content_url",
    //   "className": "col-span-6",
    //   "type": "text",
    //   "name": "content_url",
    //   "formType": "multiInput",
    //   note: "Type and press Enter to add more values",
    //   "label": "Content URL",
    //   "placeholder": "Enter Content URL",
    //   "validation": { "required": "Content URL is required" }
    // },
    // --- Welcome Note ---
    {
      fieldName: "Welcome Note (EN)",
      fieldValue: "field_welcome_note_en",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_note_en",
      formType: "input",
      label: "Welcome Note (EN)",
      placeholder: "Enter Welcome Note (EN)",
      validation: { required: "Welcome Note (EN) is Required" }
    },
    {
      fieldName: "Welcome Note (MS)",
      fieldValue: "field_welcome_note_ms",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_note_ms",
      formType: "input",
      label: "Welcome Note (MS)",
      placeholder: "Enter Welcome Note (MS)",
      // validation: { required: "Welcome Note (MS) is Required" }
    },
    {
      fieldName: "Welcome Note (ZH)",
      fieldValue: "field_welcome_note_zh",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_note_zh",
      formType: "input",
      label: "Welcome Note (ZH)",
      placeholder: "Enter Welcome Note (ZH)",
      // validation: { required: "Welcome Note (ZH) is Required" }
    },
    {
      fieldName: "Welcome Note URL",
      fieldValue: "field_welcome_note_url",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_note_url",
      formType: "input",
      label: "Welcome Note URL",
      placeholder: "Enter Welcome Note URL",
      validation: { required: "Welcome Note URL is Required" }
    },

    // --- About Us ---
    {
      fieldName: "About Us (EN)",
      fieldValue: "field_about_us_en",
      className: "col-span-6",
      type: "text",
      name: "field_about_us_en",
      formType: "input",
      label: "About Us (EN)",
      placeholder: "Enter About Us (EN)",
      validation: { required: "About Us (EN) is Required" }
    },
    {
      fieldName: "About Us (MS)",
      fieldValue: "field_about_us_ms",
      className: "col-span-6",
      type: "text",
      name: "field_about_us_ms",
      formType: "input",
      label: "About Us (MS)",
      placeholder: "Enter About Us (MS)",
      // validation: { required: "About Us (MS) is Required" }
    },
    {
      fieldName: "About Us (ZH)",
      fieldValue: "field_about_us_zh",
      className: "col-span-6",
      type: "text",
      name: "field_about_us_zh",
      formType: "input",
      label: "About Us (ZH)",
      placeholder: "Enter About Us (ZH)",
      // validation: { required: "About Us (ZH) is Required" }
    },
    {
      fieldName: "About Us URL",
      fieldValue: "field_about_us_url",
      className: "col-span-6",
      type: "text",
      name: "field_about_us_url",
      formType: "input",
      label: "About Us URL",
      placeholder: "Enter About Us URL",
      validation: { required: "About Us URL is Required" }
    },

    // --- Awards ---
    {
      fieldName: "Awards (EN)",
      fieldValue: "field_awards_en",
      className: "col-span-6",
      type: "text",
      name: "field_awards_en",
      formType: "input",
      label: "Awards (EN)",
      placeholder: "Enter Awards (EN)",
      validation: { required: "Awards (EN) is Required" }
    },
    {
      fieldName: "Awards (MS)",
      fieldValue: "field_awards_ms",
      className: "col-span-6",
      type: "text",
      name: "field_awards_ms",
      formType: "input",
      label: "Awards (MS)",
      placeholder: "Enter Awards (MS)",
      // validation: { required: "Awards (MS) is Required" }
    },
    {
      fieldName: "Awards (ZH)",
      fieldValue: "field_awards_zh",
      className: "col-span-6",
      type: "text",
      name: "field_awards_zh",
      formType: "input",
      label: "Awards (ZH)",
      placeholder: "Enter Awards (ZH)",
      // validation: { required: "Awards (ZH) is Required" }
    },
    {
      fieldName: "Awards URL",
      fieldValue: "field_awards_url",
      className: "col-span-6",
      type: "text",
      name: "field_awards_url",
      formType: "input",
      label: "Awards URL",
      placeholder: "Enter Awards URL",
      validation: { required: "Awards URL is Required" }
    },

    // --- News ---
    {
      fieldName: "News (EN)",
      fieldValue: "field_news_en",
      className: "col-span-6",
      type: "text",
      name: "field_news_en",
      formType: "input",
      label: "News (EN)",
      placeholder: "Enter News (EN)",
      validation: { required: "News (EN) is Required" }
    },
    {
      fieldName: "News (MS)",
      fieldValue: "field_news_ms",
      className: "col-span-6",
      type: "text",
      name: "field_news_ms",
      formType: "input",
      label: "News (MS)",
      placeholder: "Enter News (MS)",
      // validation: { required: "News (MS) is Required" }
    },
    {
      fieldName: "News (ZH)",
      fieldValue: "field_news_zh",
      className: "col-span-6",
      type: "text",
      name: "field_news_zh",
      formType: "input",
      label: "News (ZH)",
      placeholder: "Enter News (ZH)",
      // validation: { required: "News (ZH) is Required" }
    },
    {
      fieldName: "News URL",
      fieldValue: "field_news_url",
      className: "col-span-6",
      type: "text",
      name: "field_news_url",
      formType: "input",
      label: "News URL",
      placeholder: "Enter News URL",
      validation: { required: "News URL is Required" }
    },

    // --- Career ---
    {
      fieldName: "Career (EN)",
      fieldValue: "field_career_en",
      className: "col-span-6",
      type: "text",
      name: "field_career_en",
      formType: "input",
      label: "Career (EN)",
      placeholder: "Enter Career (EN)",
      validation: { required: "Career (EN) is Required" }
    },
    {
      fieldName: "Career (MS)",
      fieldValue: "field_career_ms",
      className: "col-span-6",
      type: "text",
      name: "field_career_ms",
      formType: "input",
      label: "Career (MS)",
      placeholder: "Enter Career (MS)",
      // validation: { required: "Career (MS) is Required" }
    },
    {
      fieldName: "Career (ZH)",
      fieldValue: "field_career_zh",
      className: "col-span-6",
      type: "text",
      name: "field_career_zh",
      formType: "input",
      label: "Career (ZH)",
      placeholder: "Enter Career (ZH)",
      // validation: { required: "Career (ZH) is Required" }
    },
    {
      fieldName: "Career URL",
      fieldValue: "field_career_url",
      className: "col-span-6",
      type: "text",
      name: "field_career_url",
      formType: "input",
      label: "Career URL",
      placeholder: "Enter Career URL",
      validation: { required: "Career URL is Required" }
    },

    // --- Contact Us ---
    {
      fieldName: "Contact Us (EN)",
      fieldValue: "field_contact_us_en",
      className: "col-span-6",
      type: "text",
      name: "field_contact_us_en",
      formType: "input",
      label: "Contact Us (EN)",
      placeholder: "Enter Contact Us (EN)",
      validation: { required: "Contact Us (EN) is Required" }
    },
    {
      fieldName: "Contact Us (MS)",
      fieldValue: "field_contact_us_ms",
      className: "col-span-6",
      type: "text",
      name: "field_contact_us_ms",
      formType: "input",
      label: "Contact Us (MS)",
      placeholder: "Enter Contact Us (MS)",
      // validation: { required: "Contact Us (MS) is Required" }
    },
    {
      fieldName: "Contact Us (ZH)",
      fieldValue: "field_contact_us_zh",
      className: "col-span-6",
      type: "text",
      name: "field_contact_us_zh",
      formType: "input",
      label: "Contact Us (ZH)",
      placeholder: "Enter Contact Us (ZH)",
      // validation: { required: "Contact Us (ZH) is Required" }
    },
    {
      fieldName: "Contact Us URL",
      fieldValue: "field_contact_us_url",
      className: "col-span-6",
      type: "text",
      name: "field_contact_us_url",
      formType: "input",
      label: "Contact Us URL",
      placeholder: "Enter Contact Us URL",
      validation: { required: "Contact Us URL is Required" }
    }

  ],
  eramanLogo: [
    {
      "fieldName": "Header Logo",
      "fieldValue": "field_brand_image",
      "className": "col-span-6",
      usedFileType: 'image/*',
      "type": "image",
      "name": "field_brand_image",
      "formType": "file",
      "label": "Header Logo",
      "placeholder": "Enter Header Logo",
      validation: { required: 'Header Logo is Required' },
      imageDimension: {
        width: 250,
        height: 80
      }
    },
    {
      "fieldName": "Footer Logo",
      "fieldValue": "field_common_image",
      "className": "col-span-6",
      usedFileType: 'image/*',
      "type": "image",
      "name": "field_common_image",
      "formType": "file",
      "label": "Footer Logo",
      "placeholder": "Enter Footer Logo",
      validation: { required: 'Footer Logo is Required' },
      imageDimension: {
        width: 250,
        height: 80
      }
    },
  ],
  eramanPrivilege: [
    {
      "fieldName": "Title (EN)",
      "fieldValue": "field_eraman_title_en",
      "className": "col-span-6",
      "type": "text",
      "name": "field_eraman_title_en",
      "formType": "input",
      "label": "Title (EN)",
      "placeholder": "Enter Title (EN)",
      validation: { required: 'Title (EN) is Required' }
    },
    {
      "fieldName": "Title (MS)",
      "fieldValue": "field_eraman_title_ms",
      "className": "col-span-6",
      "type": "text",
      "name": "field_eraman_title_ms",
      "formType": "input",
      "label": "Title (MS)",
      "placeholder": "Enter Title (MS)",
      // validation:{required:'Title (MS) is Required'}
    },
    {
      "fieldName": "Title (ZH)",
      "fieldValue": "field_eraman_title_zh",
      "className": "col-span-6",
      "type": "text",
      "name": "field_eraman_title_zh",
      "formType": "input",
      "label": "Title (ZH)",
      "placeholder": "Enter Title (ZH)",
      // validation:{required:'Title (ZH) is Required'}
    },
    {
      fieldName: "Membership Application (EN)",
      fieldValue: "field_membership_application_en",
      className: "col-span-6",
      type: "text",
      name: "field_membership_application_en",
      formType: "input",
      label: "Membership Application (EN)",
      placeholder: "Enter Membership Application (EN)",
      validation: { required: "Membership Application (EN) is Required" }
    },
    {
      fieldName: "Membership Application (MS)",
      fieldValue: "field_membership_application_ms",
      className: "col-span-6",
      type: "text",
      name: "field_membership_application_ms",
      formType: "input",
      label: "Membership Application (MS)",
      placeholder: "Enter Membership Application (MS)",
      // validation: { required: "Membership Application (MS) is Required" }
    },
    {
      fieldName: "Membership Application (ZH)",
      fieldValue: "field_membership_application_zh",
      className: "col-span-6",
      type: "text",
      name: "field_membership_application_zh",
      formType: "input",
      label: "Membership Application (ZH)",
      placeholder: "Enter Membership Application (ZH)",
      // validation: { required: "Membership Application (ZH) is Required" }
    },
    // {
    //   fieldName: "Membership Application URL",
    //   fieldValue: "field_welcome_note_url",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "field_welcome_note_url",
    //   formType: "input",
    //   label: "Membership Application URL",
    //   placeholder: "Enter Membership Application URL",
    //   validation: { required: "Membership Application URL is Required" }
    // },
    {
      fieldName: "Terms & Conditions (EN)",
      fieldValue: "field_term_conditions_en",
      className: "col-span-6",
      type: "text",
      name: "field_term_conditions_en",
      formType: "input",
      label: "Terms & Conditions (EN)",
      placeholder: "Enter Terms & Conditions (EN)",
      validation: { required: "Terms & Conditions (EN) is Required" }
    },
    {
      fieldName: "Terms & Conditions (MS)",
      fieldValue: "field_term_conditions_ms",
      className: "col-span-6",
      type: "text",
      name: "field_term_conditions_ms",
      formType: "input",
      label: "Terms & Conditions (MS)",
      placeholder: "Enter Terms & Conditions (MS)",
      // validation: { required: "About Us (MS) is Required" }
    },
    {
      fieldName: "Terms & Conditions (ZH)",
      fieldValue: "field_term_conditions_zh",
      className: "col-span-6",
      type: "text",
      name: "field_term_conditions_zh",
      formType: "input",
      label: "Terms & Conditions (ZH)",
      placeholder: "Enter Terms & Conditions (ZH)",
      // validation: { required: "About Us (ZH) is Required" }
    },
    {
      fieldName: "Terms & Conditions URL",
      fieldValue: "field_terms_url",
      className: "col-span-6",
      type: "text",
      name: "field_terms_url",
      formType: "input",
      label: "Terms & Conditions URL",
      placeholder: "Enter Terms & Conditions URL",
      validation: { required: "Terms & Conditions URL is Required" }
    },

    // --- Awards ---
    {
      fieldName: "FAQ (EN)",
      fieldValue: "field_faq_en",
      className: "col-span-6",
      type: "text",
      name: "field_faq_en",
      formType: "input",
      label: "FAQ (EN)",
      placeholder: "Enter FAQ (EN)",
      validation: { required: "FAQ (EN) is Required" }
    },
    {
      fieldName: "FAQ (MS)",
      fieldValue: "field_faq_ms",
      className: "col-span-6",
      type: "text",
      name: "field_faq_ms",
      formType: "input",
      label: "FAQ (MS)",
      placeholder: "Enter FAQ (MS)",
      // validation: { required: "FAQ (MS) is Required" }
    },
    {
      fieldName: "FAQ (ZH)",
      fieldValue: "field_faq_zh",
      className: "col-span-6",
      type: "text",
      name: "field_faq_zh",
      formType: "input",
      label: "FAQ (ZH)",
      placeholder: "Enter FAQ (ZH)",
      // validation: { required: "FAQ (ZH) is Required" }
    },
    {
      fieldName: "FAQ URL",
      fieldValue: "field_faq_url",
      className: "col-span-6",
      type: "text",
      name: "field_faq_url",
      formType: "input",
      label: "FAQ URL",
      placeholder: "Enter FAQ URL",
      validation: { required: "Awards FAQ is Required" }
    },
  ],
  aboutEraman: [
    {
      "fieldName": "Title (EN)",
      "fieldValue": "content_title_en",
      "className": "col-span-6",
      "type": "text",
      "name": "content_title_en",
      "formType": "input",
      "label": "Title (EN)",
      "placeholder": "Enter Title (EN)",
      validation: { required: 'Title (EN) is Required' }
    },
    {
      "fieldName": "Title (MS)",
      "fieldValue": "content_title_ms",
      "className": "col-span-6",
      "type": "text",
      "name": "content_title_ms",
      "formType": "input",
      "label": "Title (MS)",
      "placeholder": "Enter Title (MS)",
      // validation:{required:'Title (MS) is Required'}
    },
    {
      "fieldName": "Title (ZH)",
      "fieldValue": "content_title_zh",
      "className": "col-span-6",
      "type": "text",
      "name": "content_title_zh",
      "formType": "input",
      "label": "Title (ZH)",
      "placeholder": "Enter Title (ZH)",
      // validation:{required:'Title (ZH) is Required'}
    },
    // {
    //   "fieldName": "Content Text (EN)",
    //   "fieldValue": "content_text_en",
    //   "className": "col-span-6",
    //   "type": "text",
    //   "name": "content_text_en",
    //   "formType": "multiInput",
    //   note: "Type and press Enter to add more values",
    //   "label": "Content Text (EN)",
    //   "placeholder": "Enter Content Text (EN)",
    //   "validation": { "required": "Content Text (EN) is required" }
    // },
    // {
    //   "fieldName": "Content Text (MS)",
    //   "fieldValue": "content_text_ms",
    //   "className": "col-span-6",
    //   "type": "text",
    //   "name": "content_text_ms",
    //   "formType": "multiInput",
    //   note: "Type and press Enter to add more values",
    //   "label": "Content Text (MS)",
    //   "placeholder": "Enter Content Text (MS)",
    //   // "validation": { "required": "Content Text (MS) is required" }
    // },
    // {
    //   "fieldName": "Content Text (ZH)",
    //   "fieldValue": "content_text_zh",
    //   "className": "col-span-6",
    //   "type": "text",
    //   "name": "content_text_zh",
    //   "formType": "multiInput",
    //   note: "Type and press Enter to add more values",
    //   "label": "Content Text (ZH)",
    //   "placeholder": "Enter Content Text (ZH)",
    //   // "validation": { "required": "Content Text (ZH) is required" }
    // },
    // {
    //   "fieldName": "Content URL",
    //   "fieldValue": "content_url",
    //   "className": "col-span-6",
    //   "type": "text",
    //   "name": "content_url",
    //   "formType": "multiInput",
    //   note: "Type and press Enter to add more values",
    //   "label": "Content URL",
    //   "placeholder": "Enter Content URL",
    //   "validation": { "required": "Content URL is required" }
    // },
    // --- Welcome Note ---
    {
      fieldName: "Welcome Note (EN)",
      fieldValue: "field_welcome_note_en",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_note_en",
      formType: "input",
      label: "Welcome Note (EN)",
      placeholder: "Enter Welcome Note (EN)",
      validation: { required: "Welcome Note (EN) is Required" }
    },
    {
      fieldName: "Welcome Note (MS)",
      fieldValue: "field_welcome_note_ms",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_note_ms",
      formType: "input",
      label: "Welcome Note (MS)",
      placeholder: "Enter Welcome Note (MS)",
      // validation: { required: "Welcome Note (MS) is Required" }
    },
    {
      fieldName: "Welcome Note (ZH)",
      fieldValue: "field_welcome_note_zh",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_note_zh",
      formType: "input",
      label: "Welcome Note (ZH)",
      placeholder: "Enter Welcome Note (ZH)",
      // validation: { required: "Welcome Note (ZH) is Required" }
    },
    {
      fieldName: "Welcome Note URL",
      fieldValue: "field_welcome_note_url",
      className: "col-span-6",
      type: "text",
      name: "field_welcome_note_url",
      formType: "input",
      label: "Welcome Note URL",
      placeholder: "Enter Welcome Note URL",
      validation: { required: "Welcome Note URL is Required" }
    },

    // --- About Us ---
    {
      fieldName: "About Us (EN)",
      fieldValue: "field_about_us_en",
      className: "col-span-6",
      type: "text",
      name: "field_about_us_en",
      formType: "input",
      label: "About Us (EN)",
      placeholder: "Enter About Us (EN)",
      validation: { required: "About Us (EN) is Required" }
    },
    {
      fieldName: "About Us (MS)",
      fieldValue: "field_about_us_ms",
      className: "col-span-6",
      type: "text",
      name: "field_about_us_ms",
      formType: "input",
      label: "About Us (MS)",
      placeholder: "Enter About Us (MS)",
      // validation: { required: "About Us (MS) is Required" }
    },
    {
      fieldName: "About Us (ZH)",
      fieldValue: "field_about_us_zh",
      className: "col-span-6",
      type: "text",
      name: "field_about_us_zh",
      formType: "input",
      label: "About Us (ZH)",
      placeholder: "Enter About Us (ZH)",
      // validation: { required: "About Us (ZH) is Required" }
    },
    {
      fieldName: "About Us URL",
      fieldValue: "field_about_us_url",
      className: "col-span-6",
      type: "text",
      name: "field_about_us_url",
      formType: "input",
      label: "About Us URL",
      placeholder: "Enter About Us URL",
      validation: { required: "About Us URL is Required" }
    },

    // --- Awards ---
    {
      fieldName: "Awards (EN)",
      fieldValue: "field_awards_en",
      className: "col-span-6",
      type: "text",
      name: "field_awards_en",
      formType: "input",
      label: "Awards (EN)",
      placeholder: "Enter Awards (EN)",
      validation: { required: "Awards (EN) is Required" }
    },
    {
      fieldName: "Awards (MS)",
      fieldValue: "field_awards_ms",
      className: "col-span-6",
      type: "text",
      name: "field_awards_ms",
      formType: "input",
      label: "Awards (MS)",
      placeholder: "Enter Awards (MS)",
      // validation: { required: "Awards (MS) is Required" }
    },
    {
      fieldName: "Awards (ZH)",
      fieldValue: "field_awards_zh",
      className: "col-span-6",
      type: "text",
      name: "field_awards_zh",
      formType: "input",
      label: "Awards (ZH)",
      placeholder: "Enter Awards (ZH)",
      // validation: { required: "Awards (ZH) is Required" }
    },
    {
      fieldName: "Awards URL",
      fieldValue: "field_awards_url",
      className: "col-span-6",
      type: "text",
      name: "field_awards_url",
      formType: "input",
      label: "Awards URL",
      placeholder: "Enter Awards URL",
      validation: { required: "Awards URL is Required" }
    },

    // --- News ---
    {
      fieldName: "News (EN)",
      fieldValue: "field_news_en",
      className: "col-span-6",
      type: "text",
      name: "field_news_en",
      formType: "input",
      label: "News (EN)",
      placeholder: "Enter News (EN)",
      validation: { required: "News (EN) is Required" }
    },
    {
      fieldName: "News (MS)",
      fieldValue: "field_news_ms",
      className: "col-span-6",
      type: "text",
      name: "field_news_ms",
      formType: "input",
      label: "News (MS)",
      placeholder: "Enter News (MS)",
      // validation: { required: "News (MS) is Required" }
    },
    {
      fieldName: "News (ZH)",
      fieldValue: "field_news_zh",
      className: "col-span-6",
      type: "text",
      name: "field_news_zh",
      formType: "input",
      label: "News (ZH)",
      placeholder: "Enter News (ZH)",
      // validation: { required: "News (ZH) is Required" }
    },
    {
      fieldName: "News URL",
      fieldValue: "field_news_url",
      className: "col-span-6",
      type: "text",
      name: "field_news_url",
      formType: "input",
      label: "News URL",
      placeholder: "Enter News URL",
      validation: { required: "News URL is Required" }
    },

    // --- Career ---
    {
      fieldName: "Career (EN)",
      fieldValue: "field_career_en",
      className: "col-span-6",
      type: "text",
      name: "field_career_en",
      formType: "input",
      label: "Career (EN)",
      placeholder: "Enter Career (EN)",
      validation: { required: "Career (EN) is Required" }
    },
    {
      fieldName: "Career (MS)",
      fieldValue: "field_career_ms",
      className: "col-span-6",
      type: "text",
      name: "field_career_ms",
      formType: "input",
      label: "Career (MS)",
      placeholder: "Enter Career (MS)",
      // validation: { required: "Career (MS) is Required" }
    },
    {
      fieldName: "Career (ZH)",
      fieldValue: "field_career_zh",
      className: "col-span-6",
      type: "text",
      name: "field_career_zh",
      formType: "input",
      label: "Career (ZH)",
      placeholder: "Enter Career (ZH)",
      // validation: { required: "Career (ZH) is Required" }
    },
    {
      fieldName: "Career URL",
      fieldValue: "field_career_url",
      className: "col-span-6",
      type: "text",
      name: "field_career_url",
      formType: "input",
      label: "Career URL",
      placeholder: "Enter Career URL",
      validation: { required: "Career URL is Required" }
    },

    // --- Contact Us ---
    {
      fieldName: "Contact Us (EN)",
      fieldValue: "field_contact_us_en",
      className: "col-span-6",
      type: "text",
      name: "field_contact_us_en",
      formType: "input",
      label: "Contact Us (EN)",
      placeholder: "Enter Contact Us (EN)",
      validation: { required: "Contact Us (EN) is Required" }
    },
    {
      fieldName: "Contact Us (MS)",
      fieldValue: "field_contact_us_ms",
      className: "col-span-6",
      type: "text",
      name: "field_contact_us_ms",
      formType: "input",
      label: "Contact Us (MS)",
      placeholder: "Enter Contact Us (MS)",
      // validation: { required: "Contact Us (MS) is Required" }
    },
    {
      fieldName: "Contact Us (ZH)",
      fieldValue: "field_contact_us_zh",
      className: "col-span-6",
      type: "text",
      name: "field_contact_us_zh",
      formType: "input",
      label: "Contact Us (ZH)",
      placeholder: "Enter Contact Us (ZH)",
      // validation: { required: "Contact Us (ZH) is Required" }
    },
    {
      fieldName: "Contact Us URL",
      fieldValue: "field_contact_us_url",
      className: "col-span-6",
      type: "text",
      name: "field_contact_us_url",
      formType: "input",
      label: "Contact Us URL",
      placeholder: "Enter Contact Us URL",
      validation: { required: "Contact Us URL is Required" }
    }

  ],
  travellersInfo: [
    {
      "fieldName": "Title (EN)",
      "fieldValue": "field_travellers_info_en",
      "className": "col-span-6",
      "type": "text",
      "name": "field_travellers_info_en",
      "formType": "input",
      "label": "Title (EN)",
      "placeholder": "Enter Title (EN)",
      validation: { required: 'Title (EN) is Required' }
    },
    {
      "fieldName": "Title (MS)",
      "fieldValue": "field_travellers_info_ms",
      "className": "col-span-6",
      "type": "text",
      "name": "field_travellers_info_ms",
      "formType": "input",
      "label": "Title (MS)",
      "placeholder": "Enter Title (MS)",
      // validation:{required:'Title (MS) is Required'}
    },
    {
      "fieldName": "Title (ZH)",
      "fieldValue": "field_travellers_info_zh",
      "className": "col-span-6",
      "type": "text",
      "name": "field_travellers_info_zh",
      "formType": "input",
      "label": "Title (ZH)",
      "placeholder": "Enter Title (ZH)",
      // validation:{required:'Title (ZH) is Required'}
    },
    {
      fieldName: "Baggage Guide (EN)",
      fieldValue: "field_baggage_guide_en",
      className: "col-span-6",
      type: "text",
      name: "field_baggage_guide_en",
      formType: "input",
      label: "Baggage Guide (EN)",
      placeholder: "Enter Baggage Guide (EN)",
      validation: { required: "Baggage Guide (EN) is Required" }
    },
    {
      fieldName: "Baggage Guide (MS)",
      fieldValue: "field_baggage_guide_ms",
      className: "col-span-6",
      type: "text",
      name: "field_baggage_guide_ms",
      formType: "input",
      label: "Baggage Guide (MS)",
      placeholder: "Enter Baggage Guide (MS)",
      // validation: { required: "Welcome Note (MS) is Required" }
    },
    {
      fieldName: "Baggage Guide (ZH)",
      fieldValue: "field_baggage_guide_zh",
      className: "col-span-6",
      type: "text",
      name: "field_baggage_guide_zh",
      formType: "input",
      label: "Baggage Guide (ZH)",
      placeholder: "Enter Baggage Guide (ZH)",
      // validation: { required: "Welcome Note (ZH) is Required" }
    },
    {
      fieldName: "Baggage Guide URL",
      fieldValue: "field_baggage_guide_url",
      className: "col-span-6",
      type: "text",
      name: "field_baggage_guide_url",
      formType: "input",
      label: "Baggage Guide URL",
      placeholder: "Enter Baggage Guide URL",
      validation: { required: "Baggage Guide URL is Required" }
    },

    {
      fieldName: "LAGs & Restricted Items (EN)",
      fieldValue: "field_lag_restrict_en",
      className: "col-span-6",
      type: "text",
      name: "field_lag_restrict_en",
      formType: "input",
      label: "ALAGs & Restricted Items (EN)",
      placeholder: "Enter LAGs & Restricted Items (EN)",
      validation: { required: "LAGs & Restricted Items (EN) is Required" }
    },
    {
      fieldName: "LAGs & Restricted Items (MS)",
      fieldValue: "field_lag_restrict_ms",
      className: "col-span-6",
      type: "text",
      name: "field_lag_restrict_ms",
      formType: "input",
      label: "LAGs & Restricted Items (MS)",
      placeholder: "Enter LAGs & Restricted Items (MS)",
      // validation: { required: "About Us (MS) is Required" }
    },
    {
      fieldName: "LAGs & Restricted Items (ZH)",
      fieldValue: "field_lag_restrict_zh",
      className: "col-span-6",
      type: "text",
      name: "field_lag_restrict_zh",
      formType: "input",
      label: "LAGs & Restricted Items (ZH)",
      placeholder: "Enter LAGs & Restricted Items (ZH)",
      // validation: { required: "About Us (ZH) is Required" }
    },
    {
      fieldName: "LAGs & Restricted Items URL",
      fieldValue: "field_lags_restrict_url",
      className: "col-span-6",
      type: "text",
      name: "field_lags_restrict_url",
      formType: "input",
      label: "LAGs & Restricted Items URL",
      placeholder: "Enter LAGs & Restricted Items URL",
      validation: { required: "LAGs & Restricted Items URL is Required" }
    },

    {
      fieldName: "Duty Free Buying Guide (EN)",
      fieldValue: "field_duty_free_en",
      className: "col-span-6",
      type: "text",
      name: "field_duty_free_en",
      formType: "input",
      label: "Duty Free Buying Guide (EN)",
      placeholder: "Enter Duty Free Buying Guide (EN)",
      validation: { required: "Duty Free Buying Guide (EN) is Required" }
    },
    {
      fieldName: "Duty Free Buying Guide (MS)",
      fieldValue: "field_duty_free_ms",
      className: "col-span-6",
      type: "text",
      name: "field_duty_free_ms",
      formType: "input",
      label: "Duty Free Buying Guide (MS)",
      placeholder: "Enter Duty Free Buying Guide (MS)",
      // validation: { required: "Duty Free Buying Guide (MS) is Required" }
    },
    {
      fieldName: "Duty Free Buying Guide (ZH)",
      fieldValue: "field_duty_free_zh",
      className: "col-span-6",
      type: "text",
      name: "field_duty_free_zh",
      formType: "input",
      label: "Duty Free Buying Guide (ZH)",
      placeholder: "Enter Duty Free Buying Guide (ZH)",
      // validation: { required: "Duty Free Buying Guide (ZH) is Required" }
    },
    {
      fieldName: "Duty Free Buying Guide URL",
      fieldValue: "field_duty_free_url",
      className: "col-span-6",
      type: "text",
      name: "field_duty_free_url",
      formType: "input",
      label: "Duty Free Buying Guide URL",
      placeholder: "Enter Duty Free Buying Guide URL",
      validation: { required: "Duty Free Buying Guide URL is Required" }
    },
  ],
};
